<template>
    <div name="mainbanner" class="mainbanner" id="mainbanner">
        <div ref="sectionWrap" class="section-wrap">
            <div class="section section1">
                <div class="video-area">
                    <video autoplay muted loop class="bg-video">
                        <source src="../../assets/partners_pc/partners_main_pc.mp4" type="video/mp4">
                    </video>
                </div>
                
                <div class="title-area">
                    <h2 class="title">신환모객부터<br>매출상승까지<br>솔닥파트너스</h2>
                    <p class="sub-text">의료진 전용 올인원 솔루션<br>환자 CRM + 클라우드 EMR</p>
                </div>      
                <button class="btn-section-mouse" title="다음으로 이동" @click="buttonMouse">
                    <img class="section-mouse" src="../../assets/partners_pc/img_mouse_arrow.png" alt="">
                    <img class="mouse-arrow" src="../../assets/partners_pc/img_chevron_down.png" alt="">
                </button>
            </div>
            <div class="section section2">
                <div class="section-inner">
                    <div class="text-area">
                        <strong>기존 EMR 교체 필요 없이<br>함께 사용하세요</strong>
                        <p>솔닥 환자 진료는 솔닥파트너스로.<br>기존 차트에 옮겨적는 번거로움 없이 관리할 수 있습니다.</p>
                    </div>
                    <div class="content-area logo-box-area">
                        <ul class="logo-box">
                            <li><img src="../../assets/partners_pc/img_logo1.png" alt="의사랑" /></li>
                            <li><img src="../../assets/partners_pc/img_logo2.png" alt="비트U차트" /></li>
                            <li><img src="../../assets/partners_pc/img_logo3.png" alt="eghis" /></li>
                            <li><img src="../../assets/partners_pc/img_logo4.png" alt="포인트닉스" /></li>
                            <li><img src="../../assets/partners_pc/img_logo5.png" alt="엣지앤넥스트" /></li>
                            <li><img src="../../assets/partners_pc/img_logo6.png" alt="오름차트" /></li>
                            <li><img src="../../assets/partners_pc/img_logo7.png" alt="닥터팔레트" /></li>
                            <li><img src="../../assets/partners_pc/img_logo8.png" alt="truedoc" /></li>
                            <li></li>
                            <li></li>
                            <li></li>
                            <li></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="section section3">
                <div class="section-inner">
                    <p class="text-area">솔닥파트너스로 만나는 <strong>놀라운</strong> 변화</p>
                </div>
            </div>
            <div ref="section4" class="section section4">
                <div class="section-inner">
                    <div class="text-area">
                        <h3>50만 솔닥 이용자<br> 우리 병원 고객이 됩니다</h3>
                    </div>
                    <ul class="content-area data-area">
                        <li>
                            <dl>
                                <dt>이용자 만족도</dt>
                                <dd class="num-data">
                                    <strong ref="number1">00</strong>%
                                </dd>
                            </dl>
                            <p>솔닥 자체 VOC 집계 기준<br>(22' 3Q - 23' 4Q)</p>
                        </li>
                        <li>
                            <dl>
                                <dt>누적 진료 수</dt>
                                <dd class="num-data">
                                    <strong ref="number2">00</strong>만+
                                </dd>
                            </dl>
                            <p>솔닥 누적 진료 중개 건 수<br>(22' 1Q - 23' 4Q)</p>
                        </li>
                        <li>
                            <dl>
                                <dt>동일병원 재진율</dt>
                                <dd class="num-data">
                                    <strong ref="number3">00</strong>%
                                </dd>
                            </dl>
                            <p>솔닥 재진율<br>(22' 1Q - 23' 4Q)</p>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="section section5">
                <img src="../../assets/partners_pc/bg_soldoc_partners_effect.png" alt="" class="bg-image" />
                <div class="section-inner">
                    <div class="title-area">
                        <span class="sub-text">FOR PARTNERS ONLY</span>
                        <h3 class="title">솔닥파트너스가<br>다 해드립니다</h3>
                    </div>

                    <div class="card-wrap">
                        <div class="card-item">
                            <img class="ico" src="../../assets/partners_pc/ico_soldoc_partners_effect1.png" alt="" />
                            <strong class="card-tit">50만 솔닥 이용자를<br>우리 병원 환자로</strong>
                            <p>누적 진료수 59만 건 돌파,<br>솔닥 이용자는 오직<br>솔닥파트너스에서만 만날 수 있습니다.</p>
                        </div>
                        <div class="card-item">
                            <img class="ico" src="../../assets/partners_pc/ico_soldoc_partners_effect2.png" alt="" />
                            <strong class="card-tit">병원 매출,<br>최대 342% 상승</strong>
                            <p>평균 신환 증가율 38%, 재진율 89% 개선<br>기존 도입 의원이 증명하는 검증된 솔루션</p>
                            <span>*2023년 12월 기준 상위 13개 기관</span>
                        </div>
                        <div class="card-item">
                            <img class="ico" src="../../assets/partners_pc/ico_soldoc_partners_effect3.png" alt="" />
                            <strong class="card-tit">마케팅부터 물류까지<br>올인원 토탈 케어</strong>
                            <p>병원 마케팅, CS 지원,<br>의료기기 물류 관리까지 솔닥파트너스의<br>병의원 전문 올인원 토탈케어</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'mainbanner',
    data() {
    return {
        currentIndex: 0,
        aniRef: 'aniDiv',
        maxNum1 : 94,
        maxNum2 : 59,
        maxNum3 : 85,
        currentNum1: 0,
        currentNum2: 0,
        currentNum3: 0,
        interval1: null,
        interval2: null,
        interval3: null,
        section4Visible: false,
        section4AnimationStarted: false,
        };
    },
    methods: {
        startImageSlider() {
            setInterval(() => {
                this.currentIndex++;
                }, 5000);
        },

        buttonMouse() {
            let height = window.scrollY;
            let oneVhHeight = window.innerHeight;

            if (height < oneVhHeight) {
                this.scrollToPosition(oneVhHeight);
            }
        },

        scrollToPosition(position) {
            window.scrollTo({
                top: position,
                behavior: 'smooth'
            });
        },

        startAnimation(ref, maxNum, currentNumVar, intervalVar) {
            const intervalDuration = 25;
            const totalSteps = 100;
            const stepValue = maxNum / totalSteps;

            this[intervalVar] = setInterval(() => {
            const element = this.$refs[ref];
            if (element) {
                if (this[currentNumVar] < maxNum) {
                    this[currentNumVar] += stepValue;
                    element.innerText = this[currentNumVar].toFixed(0);
                } else {
                    clearInterval(this[intervalVar]);
                    element.innerText = maxNum;
                }
            } else {
                clearInterval(this[intervalVar]);
            }}, intervalDuration);
        },
        
        handleIntersection(entries) {
            entries.forEach(entry => {
                if (entry.isIntersecting && !this.section4AnimationStarted) {
                    this.startAnimation("number1", this.maxNum1, "currentNum1", "interval1");
                    this.startAnimation("number2", this.maxNum2, "currentNum2", "interval2");
                    this.startAnimation("number3", this.maxNum3, "currentNum3", "interval3");
                }
            });
        },
    },

    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    mounted: function()
    {
        window.addEventListener('scroll', this.handleScroll);

        $('html').animate({
            scrollTop: 0
        }, 100);
        this.startImageSlider();

        $(window).scroll(function() {
            updateSections();
        });

        function updateSections() {
            var vhHeight = window.innerHeight / 100;
            var oneVh = 100 * vhHeight;
            var oneVhHeight = 100 * vhHeight - 500;
            var twoVhHeight = 200 * vhHeight - 500;
            var threeVhHeight = 300 * vhHeight - 500;
            var fourVhHeight = 400 * vhHeight - 500;
            var fiveVhHeight = 500 * vhHeight - oneVh;
            var height = $(document).scrollTop();
            // console.log(height);

            if (height < oneVhHeight) {
                updateDisplay(['.section1'], ['.section2', '.section3', '.section4', '.section5'], 'on');
            } else if (height >= oneVhHeight && height < twoVhHeight) {
                updateDisplay(['.section2'], ['.section1', '.section3', '.section4', '.section5'], 'on');
                $('.section1').removeClass('on');
                $('.section-wrap').removeClass('off');
            } else if (height >= twoVhHeight && height < threeVhHeight) {
                updateDisplay(['.section3'], ['.section1', '.section2', '.section4', '.section5'], 'on');
                $('.section-wrap').removeClass('off');
            } else if (height >= threeVhHeight && height < fourVhHeight) {
                updateDisplay(['.section4'], ['.section1', '.section2', '.section3', '.section5'], 'on');
                $('.section-wrap').removeClass('off');
            } else if (height >= fourVhHeight && height < fiveVhHeight) {
                updateDisplay(['.section5'], ['.section1', '.section2', '.section3', '.section4'], 'on');
                $('.section-wrap').removeClass('off');
            } else if (height >= fiveVhHeight + 0.1) {
                $('.section-wrap').addClass('off');
            }
        }

        function updateDisplay(showSelectors, hideSelectors, addClass) {
            $(showSelectors.join(', ')).css('display', 'inline-block').addClass(addClass);
            $(hideSelectors.join(', ')).css('display', 'none');
        }

        const observer = new IntersectionObserver(this.handleIntersection, { threshold: 0.5 });
        observer.observe(this.$refs.section4);
    },
}
</script>

<style scoped>
    .mainbanner {
        position: relative;
        top: -64px;
        width: 100%;
        height: calc(500vh - 64px);
        margin-bottom: -64px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;
        overflow: hidden;
    }
    .section-wrap {
        width: 100%;
        overflow: auto;
        height: calc(500vh - 64px);
        overflow: hidden;
    }
    .section-wrap.off {
        padding-bottom: 64px;
    }
    .section-wrap.off .section {
        position: fixed;
        display: block !important;
    }
    .section-wrap.off .bg-video {
        position: absolute;
    }
    .section-wrap.off .title-wrap {
        position: relative;
    }
    .section {
        position: relative;
        display: block;
        width: 100%;
        height: 100vh;
        overflow: hidden;
    }
    .section.on {
        position: fixed;
        top: 0;
    }
    .section1 .bg-video {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    .section1 .video-area {
        z-index: -1;
    }
    .section1 .video-area::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        width: 100%;
        height: 100%;
        background: #000;
        opacity: 0.4;
    }
    .section1 .title-area {
        position: absolute;
        top: 50%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        z-index: 1;
        transform: translateY(-50%);
    }
    .section1 .title {
        margin-bottom: 0;
        font-size: 56px;
        font-weight: 700;
        color: #fff;
        text-align: center;
        line-height: 72px;
        animation: fadeInUp 1s;
    }
    .section1 .sub-text {
        display: inline-block;
        margin-top: 32px;
        margin-bottom: 0;
        font-size: 18px;
        font-weight: 400;
        color: #FFF;
        text-align: center;
        line-height: 28px;
        animation: fadeInUp1 2s;
    }
    .section1 .btn-section-mouse {
        position: absolute;
        left: 50%;
        bottom: 19px;
        transform: translate(-50%);
        display: flex;
        flex-direction: column;
        width: 24px;
        height: 73.556px;
        margin: 0;
        padding: 0;
        background: none;
        border: none;
        z-index: 20;
    }
    .section1 .section-mouse {
        position: relative;
        display: block;
        width: 24px;
        height: 38px;
        height: auto;
    }
    .section1 .mouse-arrow {
        display: block;
        width: 24px;
        height: 26.556px;
        margin-top: 9px;
        transform-origin: 0px 0px;
        transform: translate(0, 0);
        animation: scroll-down 900ms ease-in-out infinite;
    }
    @keyframes scroll-down {
        0% {
        transform: translate(0, 3px);
        }
        30% {
        transform: translate(0, -2px);
        }       
        45% {
        transform: translate(0, 3px);
        }
        100% {
        transform: translate(0, 3px);
        }
    }
    @keyframes fadeInUp {
        0% {
            opacity: 0;
            transform: translate3d(0, 100%, 0);
        }
        to {
            opacity: 1;
            transform: translateZ(0);
        }
    }

    .section2 {
        width: 100%;
        height: 100vh;
        background: #000;
    }
    .section2 .section-inner {    
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 1240px;
        height: 100%;
        margin: 0 auto;
        padding: 14% 20px 3%;
    }
    .section2 .text-area {
        height: 664px;
        animation: fadeInUp ease-in-out 1.5s;
    }
    .section2 .text-area strong {
        font-size: 46px;
        font-weight: 600;
        line-height: 58px;
        color: #FFF;
    }
    .section2 .text-area p {
        margin-top: 51px;
        margin-bottom: 0;
        font-size: 18px;
        font-weight: 400;
        line-height: 28px;
        color: #FFF;
    }
    .section2 .logo-box-area .logo-box {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        width: 493px;
        height: 664px;
        list-style: none;
        padding: 0;
        margin: 0;
        animation: fadeInUp ease-in-out 2s;
    }
    .section2 .logo-box-area .logo-box li {
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        width: calc(50% - 6.5px);
        height: 104px;
        margin-bottom: 8px;
        border-radius: 20px;
        background: #FFF;
    }
    .section2 .logo-box-area .logo-box li:nth-child(n+11) {
        margin-bottom: 0;
    }
    .section2 .logo-box-area .logo-box li img {
        display: inline-block;
    }
    .mainbanner .section2 .logo-box-area .logo-box li:nth-child(n+9):nth-child(-n+10) {
        opacity: 0.5 !important;
    }
    .mainbanner .section2 .logo-box-area .logo-box li:nth-child(n+11):nth-child(-n+12) {
        opacity: 0.2 !important;
        background: linear-gradient(180deg, #FFF 0%, rgba(255, 255, 255, 0.00) 100%) !important;
    }
    .ani {
        position: absolute;
    }
    .start-ani {
        animation: slideUp 12s linear infinite;
    }
    .ani-content {
        display: flex;
        flex-direction: column;
    }
    .ani-content span {
        display: inline-block;
        width: 250px;
        height: 1.48em;
        line-height: 1.5;
        text-align: center;
    }

    .section3 {
        width: 100%;
        height: 100vh;
        background: #000;
    }
    .section3 .section-inner {    
        display: flex;
        justify-content: center;
        align-items: center;
        width: 1240px;
        height: 100%;
        margin: 0 auto;
    }
    .section3 .section-inner p,
    .section3 .section-inner strong {
        margin-bottom: 0;
        font-size: 46px;
        font-weight: 600;
        line-height: 50px;
        color: #FFF;
        text-align: center;
    }
    .section3 .section-inner p {
        animation: fadeInUp1 2s;
    }
    .section3 .section-inner strong {
        position: relative;
    }
    .section3 .section-inner strong::before {
        content: '';
        position: absolute;
        top: -15px;
        left: -16px;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        box-shadow: 32px 0 0 0 #008DEF, 72px 0 0 0 #008DEF, 112px 0 0 0 #008DEF;
    }
    
    .section4 {
        width: 100%;
        height: 100vh;
        background: #000;
    }
    .section4 .section-inner {    
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 1240px;
        height: 100%;
        margin: 0 auto;
    }
    .section4 .text-area {
        text-align: center;
        animation: fadeInUp1 2s;
    }
    .section4 .text-area h3 {
        min-height: 123px;
        margin-bottom: 0;
        font-size: 46px;
        font-weight: 600;
        line-height: 60px;
        color: #FFF;
    }
    .section4 .data-area {
        display: flex;
        align-items: center;
        justify-content: space-between;
        list-style: none;
        width: 1056px;
        padding: 0;
        margin: 80px 0 0;
        animation: fadeInUp1 2.5s;
    }
    .section4 .data-area dl {
        display: flex;
        flex-direction: column-reverse;
        align-items: center;
        gap: 26px;
        margin-bottom: 0;
    }
    .section4 .data-area dt {
        min-width: 181px;
        height: 48px;
        border-radius: 50px;
        border: 1px solid #008DEF;
        text-align: center;
        font-size: 24px;
        font-weight: 600;
        line-height: 46px;
        color: #008DEF;
    }
    .section4 .data-area li:last-child dt {
        width: 196px;
    }
    .section4 .data-area dd {
        margin-bottom: 0;
        text-align: center;
        font-size: 80px;
        font-weight: 700;
        line-height: 80px;
        color: #FFF;
    }
    .section4 .data-area p {
        margin-top: 17px;
        margin-bottom: 0;
        text-align: center;
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        color: #999;
    }

    .section5 {
        width: 100%;
        height: 100vh;
    }
    .section5 .section-inner {    
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 1240px;
        height: 100%;
        margin: 0 auto;
    }
    .section5 .bg-image {
        position: absolute;
        top: 0;
        left: 50%;
        min-width: 100%;
        height: auto;
        min-height: 100%;
        object-fit: contain;
        z-index: -1;
        transform: translateX(-50%);
    }
    .section5 .sub-text {
        display: block;
        font-size: 16px;
        font-weight: 600;
        line-height: 20px;
        text-align: center;
        color: #FFF;
    }
    .section5 .title {
        margin-top: 22px;
        margin-bottom: 41px;
        font-size: 46px;
        font-weight: 600;
        line-height: 60px;
        text-align: center;
        color: #FFF;
    }
    .section5 .title-area {
        justify-content: center;
        flex-direction: column;
        animation: fadeUp 2s;
    }
    .section5 .card-wrap {
        display: flex;
        flex-direction: row;
        justify-content: center;
    }
    .section5 .card-item {
        position: relative;
        width: 386px;
        min-width: 386px;
        height: 275px;
        border: 3px solid #008DEF;
        border-radius: 20px;
        background: #FFF;
        font-size: 18px;
        font-weight: 400;
        line-height: 30px;
        animation: fadeInUp4 2s;
    }
    .section5 .card-item + .card-item {
        margin-left: 20px;
    }
    .section5 .card-item:nth-child(1) .ico {
        position: absolute;
        top: 39px;
        right: 42px;
    }
    .section5 .card-item:nth-child(2) .ico {
        position: absolute;
        top: 34px;
        right: 39px;
    }
    .section5 .card-item:nth-child(3) .ico {
        position: absolute;
        top: 52px;
        right: 29px;
    }
    .section5 .card-item:nth-child(2) {
        margin-top: 106px;
    }
    .section5 .card-tit {
        position: absolute;
        top: 46px;
        left: 32px;
        margin: 0;
        font-size: 26px;
        font-weight: 600;
        line-height: 32px;
        color: #1A1A1A;
    }
    .section5 .card-item p {
        margin-bottom: 0;
        font-size: 18px;
        font-weight: 400;
        line-height: 28px;
        color: #1A1A1A;
    }
    .section5 .card-item span {
        position: absolute;
        bottom: 30px;
        left: 32px;
        font-size: 13px;
        font-weight: 400;
        line-height: 30px;
        color: #999;
    }
    .section5 .card-item:nth-child(1) p {
        position: absolute;
        bottom: 48px;
        left: 32px;
    }
    .section5 .card-item:nth-child(2) p {
        position: absolute;
        top: 139px;
        left: 32px;
    }
    .section5 .card-item:nth-child(3) p {
        position: absolute;
        top: 143px;
        left: 32px;
    }

    @keyframes fadeUp {
        0% {
            opacity: 0;
            transform: translate3d(0, 30%, 0);
        }
        to {
            opacity: 1;
            transform: translateZ(0);
        }
    }
    @keyframes fadeInUp1 {
        0% {
            opacity: 0;
            transform: translate3d(0, 200%, 0);
        }
        to {
            opacity: 1;
            transform: translateZ(0);
        }
    }
    @keyframes fadeUp2 {
        0% {
            opacity: 0;
            transform: translate3d(0, 500%, 0);
        }
        to {
            opacity: 1;
            transform: translateZ(0);
        }
    }
    @keyframes fadeInUp4 {
        0% {
            opacity: 0;
            transform: translate3d(0, 100%, 0);
        }
        to {
            opacity: 1;
            transform: translateZ(0);
        }
    }
    @keyframes slideUp {
        0%, 10% {
            top: 0;
        }
        25%, 40% {
            top: -1.48em;
        }
        55%, 70% {
            top: -2.96em;
        }
        85%, 99.98% {
            top: -4.44em;
        }
        99.99%, 100% {
            top: 0;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/pc_partners/Mainbanner.vue